type FnOptions = {
  /**
   * Object to replace empty strings with
   */
  replace?: any;
};
/**
 * Strip empty strings, arrays, and objects from an object
 * @param obj Object to strip empty strings (and arrays/objects) from
 * @param options Strip options
 * @returns Original object with empty strings, arrays, and objects stripped out or replaced with `options.replace`
 */
export function stripEmptyStrings<T>(obj: T, options?: FnOptions) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  Object.entries(obj as any).forEach(([k, v]) => {
    if (v && typeof v === 'object') {
      stripEmptyStrings(v, options);
    }
    if ((v && typeof v === 'object' && !Object.keys(v).length) || v === '') {
      if (Array.isArray(obj)) {
        obj.splice(k as unknown as number, 1);
        stripEmptyStrings(obj, options);
      } else {
        if (options?.replace !== undefined) {
          (obj as any)[k] = options.replace;
        } else {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-dynamic-delete
          delete (obj as any)[k];
        }
      }
    }
  });
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return obj;
}
